import { useAuthStore } from "@/store/auth.store"
import { RoleTypes } from "@/enums/role-types"
import { ref, watch } from "vue"

// Only the planning columns wait; controllers/stores/socket handlers must exist
// before recovery so ModelManager can resolve relationships without mounted rows.
export const planningUIReady = ref(false)
/** True while the changes since the last visit are being applied to the shown planning. */
export const retrievingUpdates = ref(false)
let recovering = false
let connectionTimeout: ReturnType<typeof setTimeout> | undefined

export function waitForPlanningRecovery() {
  if (planningUIReady.value || recovering || connectionTimeout) return
  // An unavailable socket must still permit the normal HTTP startup.
  connectionTimeout = setTimeout(() => {
    console.warn("[recovery] Connection wait expired; mounting UI for HTTP fallback")
    finishPlanningRecovery()
  }, 10000)
}

export function beginPlanningRecovery() {
  recovering = true
  retrievingUpdates.value = true
  clearTimeout(connectionTimeout)
  connectionTimeout = undefined
}

export function finishRecoveryUpdates() {
  retrievingUpdates.value = false
}

export function finishPlanningRecovery() {
  clearTimeout(connectionTimeout)
  connectionTimeout = undefined
  recovering = false
  planningUIReady.value = true
}

export function usePlanningRecovery() {
  const auth = useAuthStore()
  watch(
    () => auth.activeUser,
    (user) => {
      if (!user) return
      if (
        import.meta.env.VITE_CENTRIFUGO_URL &&
        user.knownBusinessEntityContact?.hasRole(RoleTypes.PLANNER)
      )
        waitForPlanningRecovery()
      else finishPlanningRecovery()
    },
    { immediate: true }
  )
  return planningUIReady
}
